import { ActionResponse, ActionStatusHelper, RecordMap, useAuditEnricher } from "@/Shared";
import { useMandate, useContact, useNeed, useProperty } from "@/OneLiners";

import { TransactionModel } from "../TransactionModel";

export function useTransactionEnricher() {

    const { dataMap: mandateMap, stateResponse: mandateResponse } = useMandate();
    const { dataMap: contactMap, stateResponse: contactResponse } = useContact();

    const { dataMap: needMap, stateResponse: needResponse } = useNeed();
    const { dataMap: propertyMap, stateResponse: propertyResponse } = useProperty();

    /**
             * Centralized audit enrichment hook
             * - Provides O(1) audit user resolution via precomputed Map
             * - Exposes audit status and error
             */
            const {
                enricherResponse : auditEnricherResponse,
                userMap,
                getUserById,
                getEnrichedAudit,
            } = useAuditEnricher<TransactionModel>();
    

    const enricherResponse: ActionResponse = {
        status: ActionStatusHelper.combine(
            mandateResponse.status,
            auditEnricherResponse.status,
            contactResponse.status,
            needResponse.status,
            propertyResponse.status
        ),
        error: mandateResponse.error ??
            contactResponse.error ??
            auditEnricherResponse.error ??
            mandateResponse.error ??
            propertyResponse.error
    };

    const getEnrichedTransactionMap = (transactionMap: RecordMap<TransactionModel>): RecordMap<TransactionModel> => {
                            
        return transactionMap.map<TransactionModel>(getStrictEnrichedTransaction);
    }

    const getEnrichedTransaction = (transaction?: TransactionModel) : TransactionModel | undefined => {
        return transaction ? getStrictEnrichedTransaction(transaction) : undefined;
    }

    const getStrictEnrichedTransaction = (transaction: TransactionModel) => {
        return {
            ...getEnrichedAudit(transaction),
            client: transaction.clientId ? contactMap.get(transaction.clientId) : undefined,
            advisor: transaction.advisorId ? userMap.get(transaction.advisorId) : undefined,
            mandate: transaction.mandateId ? mandateMap.get(transaction.mandateId) : undefined,
        }
    }

    /**
         * Enriches a Transaction model by its identifier.
         */
        const getEnrichedTransactionById = (transactionMap: Map<number, TransactionModel>,
            transactionId?: number | null
        ) : TransactionModel | undefined => {
            return getEnrichedTransaction(transactionId ? transactionMap.get(transactionId) : undefined) ;
        }
    

    return {
        userMap,
        contactMap,
        mandateMap,
        propertyMap,
        needMap,

        enricherResponse,
        getEnrichedTransaction,
        getStrictEnrichedTransaction,
        getEnrichedTransactionById,
        getEnrichedTransactionMap,
    }
}